import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import * as Icons from '@ant-design/icons-vue'
import { permission, menuPermission } from './directives/permission'
// 虚拟滚动
import { RecycleScroller, DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

const app = createApp(App)

// 注册虚拟滚动组件
app.component('RecycleScroller', RecycleScroller)
app.component('DynamicScroller', DynamicScroller)
app.component('DynamicScrollerItem', DynamicScrollerItem)

// 注册所有图标 已修复
Object.keys(Icons).forEach(key => {
  // 安全检查：确保 key 是字符串且是 Icons 的自有属性
  if (typeof key === 'string' && Object.prototype.hasOwnProperty.call(Icons, key)) {
    app.component(key, Icons[key])
  }
})

// 注册权限指令
app.directive('permission', permission)
app.directive('menu-permission', menuPermission)

app.use(store).use(router).use(Antd).mount('#app')

// 定时检查token是否即将过期（每分钟检查一次）
setInterval(() => {
  const isTokenExpiringSoon = store.getters['auth/isTokenExpiringSoon']
  const isTokenExpired = store.getters['auth/isTokenExpired']
  const isRefreshTokenExpired = store.getters['auth/isRefreshTokenExpired']
  const isAuthenticated = store.getters['auth/isAuthenticated']
  
  if (!isAuthenticated) {
    return
  }
  
  if (isRefreshTokenExpired) {
    store.dispatch('auth/logout')
    window.location.href = '/login'
    return
  }
  
  if (isTokenExpiringSoon || isTokenExpired) {
    store.dispatch('auth/refreshToken')
      .catch(() => {
        store.dispatch('auth/logout')
        window.location.href = '/login'
      })
  }
}, 60 * 1000)
